import Vue from "vue"
import Filters from "@/domain/core/utils/filters";

Object.getOwnPropertyNames(Filters).filter(
    method => typeof Filters[method] === 'function'
).forEach(method => {
    Vue.filter(method, Filters[method]);
})